import { _createPPT, _postSavePPT } from "@/api";
import { pptNode } from "./data";

export const handleCreatePPT = async (data: any, curentPPT: any) => {
  const payload = data.payload;
  const res: any = await _createPPT({
    cover_url: payload?.url,
    name: pptNode.value[0].title?.replace("\n", "") || pptNode.value[0].title,
    ppt_json: payload?.jsonUrl,
  });
  curentPPT.value = res;
  ElMessage.success("创建成功");
};

export const handleSavePPT = async (data: any, curentPPT: any) => {
  if (!curentPPT.value?.serial_no) return;
  const payload = data.payload?.jsonUrl;
  await _postSavePPT(curentPPT.value?.serial_no, {
    cover_url: payload?.cover_url || curentPPT.value?.cover_url,
    name: payload?.name || curentPPT.value?.name,
    ppt_json: payload?.jsonUrl || curentPPT.value?.ppt_json,
  });
};
